import { GetOtherDamagedDescriptionQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getOtherDamagedDescription/getOtherDamagedDescriptionQuery.type';
import { getOtherDamagedDescriptionFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getOtherDamagedDescription/getOtherDamagedDescriptionQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getOtherDamagedDescriptionQueryOptions = (
  params: GetOtherDamagedDescriptionQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['otherDamagedDescription', params],
    queryFn: () => getOtherDamagedDescriptionFunction(params),
    enabled: true,
    meta: {
      onSuccess: (data) => {
        params.onSuccess?.(data);
      },
    },
  });
};
